/**
 * Detection of mobile devices to be consistent with
 * our partner's mobile detection logic.
 */

export function isMobileDevice(): boolean {
  return hasTouchSupport() && isMobileBrowser()
}

function isMobileBrowser(): boolean {
  if (window.navigator.userAgentData && window.navigator.userAgentData) {
    const { mobile: isMobile } = window.navigator.userAgentData
    return isMobile
  }
  const ua = window.navigator.userAgent
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)
}

function hasTouchSupport(): boolean {
  return 'ontouchstart' in window && navigator.maxTouchPoints > 1
}
